import loadImage from "blueimp-load-image";
import React, { Fragment, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { List } from "../../../components";
import { AppContext, SET_IDCARD_STATE } from "../../../components/AppProvider";
import HeaderNavigate from "../../../components/UI/Header/HeaderNavigate";
import LabelButton from "../../../components/UI/Label/LabelButton";
import { _O } from "../../../modules/utils";
import { getCookie } from "../../../modules/utils/cookie";
import { NativeAction } from "../../../modules/utils/HandleWs";
import { loginVarify } from "../../../modules/utils/loginAction";
import { IC, ListIcon } from "../../../resources/Assets";
import {
  getIdCard,
  openIdCard,
  setIdCard,
} from "../../Nftf/Interface/NFTF/NativeApi";
import useTitle from "../../../modules/hooks/useTitle";

export default props => {
  const { phonecfg, userinfo, dispatch, idCardState } = useContext(AppContext);
  const [gender, setGender] = useState(userinfo.sex);
  const [idCardData, setIdCardData] = useState();

  useTitle("마이페이지_내정보보기");

  const getUserId = () => {
    const signUpChannel = getCookie("signUpChannel");

    if (signUpChannel === "000" || signUpChannel === "500") {
      return getCookie("userId");
    } else {
      return "SNS가입 계정";
    }
  };

  const previewImg = (file, fileName) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    return new Promise(resolve => {
      reader.onload = e => {
        setIdCardData({ file: reader.result, fileName: fileName });
        resolve();
      };
    });
  };

  const onImageUpload = fileList => {
    // 이미지 파일 데이터
    const file = fileList[0];
    // 추가된 코드
    // 1. 이미지 로드
    loadImage(
      file,
      function (img, data) {
        // 2. 이미지 파일 데이터에 imageHead와 exif가 있는지 확인
        if (data.imageHead && data.exif) {
          // 3. exif 값이 있다면 orientation 값을 1로 변경
          loadImage.writeExifData(data.imageHead, data, "Orientation", 1);
          img.toBlob(function (blob) {
            loadImage.replaceHead(
              blob,
              data.imageHead,
              async function (newBlob) {
                newBlob.name = file.name;
                // 4. 기존 메서드로 파일 s3에 업로드
                await previewImg(newBlob, newBlob.name + ".jpg");
              }
            );
          }, "image/jpeg");
        } else {
          // exif 값 없으면 바로 s3에 업로드
          previewImg(file, file.name + ".jpg");
        }
      },
      { meta: true, orientation: true, canvas: true }
    );
  };

  const encodeFileToBase64 = fileBlob => {
    onImageUpload(fileBlob);
  };

  const rtnEvent = (value, status) => {
    if (value != "-1" && value != "undefined") {
      if (status === "1") {
        setIdCardData({
          file: decodeURIComponent(value),
          fileName: userinfo.userName + ".jpg",
        });

        // setImgTempView(1);
      } else {
        setIdCardData({
          file: decodeURIComponent(value),
          fileName: userinfo.userName + ".jpg",
        });
      }
    }
  };

  const checkVersion = () => {
    if (phonecfg.phoneOS === "ANDROID") {
      if (parseInt(phonecfg.version.split(".")[2]) > 83) {
        return "notActive";
      } else {
        return "fileData";
      }
    } else {
      if (parseInt(phonecfg.version.split(".")[2]) > 37) {
        return "notActive";
      } else {
        return "fileData";
      }
    }
  };

  useEffect(() => {
    NativeAction(phonecfg, "statusColor", "#FFFFFF");
  }, [phonecfg.version]);

  useEffect(() => {
    // 진료 신청한 환자의 이름
    if (getIdCard(userinfo.userName) === "-1") {
      setIdCardData({ file: "", fileName: "" });
    }
  }, []);

  useEffect(() => {
    if (idCardState.reload) {
      if (
        idCardState &&
        idCardState.data &&
        idCardState.data != null &&
        idCardState.data.value1 != "-1" &&
        idCardState.data.value1 != "undefined"
      ) {
        rtnEvent(idCardState.data.value1, idCardState.data.value2);
      } else {
        dispatch({ type: SET_IDCARD_STATE, data: { type: "RELOAD" } });
      }
    }
  }, [idCardState.reload]);

  useEffect(() => {
    console.log("idCardState:: ", idCardState);
    if (
      idCardState &&
      idCardState.data &&
      idCardState.data != null &&
      idCardState.data.value1 != "-1" &&
      idCardState.data.value1 != "undefined"
    ) {
      setIdCard(idCardState.data.value1, userinfo.userName);
    }
  }, [idCardState]);

  return (
    <Fragment>
      <Container>
        <HeaderNavigate
          leftIcon={{
            imgSrc: IC.etc.ICON_CHEVRON_LEFT,
            action: () => _O.Open("/mp"),
          }}
          headerTitle="내 정보 보기"
        />

        <ContentsBody>
          <ContentBody style={{ paddingTop: "40px" }}>
            <Content>
              <ContentTitle>이름</ContentTitle>
              <ContentInput>{userinfo.userName}</ContentInput>
            </Content>

            <Content>
              <ContentTitle>아이디</ContentTitle>

              <div style={{ display: "flex", width: "100%", gap: "8px" }}>
                <ContentInput>{getUserId()}</ContentInput>
                <ContentButton
                  onClick={
                    getCookie("userDI") && getCookie("userDI") != ""
                      ? () => _O.Open("/membership/acntMerge")
                      : e => e.preventDefault()
                  }>
                  계정통합
                </ContentButton>
              </div>
            </Content>

            <Content>
              <ContentTitle>전화번호</ContentTitle>

              <div style={{ display: "flex", width: "100%", gap: "8px" }}>
                <ContentInput>
                  {userinfo.userPhone && userinfo.userPhone}
                </ContentInput>
                <ContentButton
                  onClick={e => loginVarify(getCookie("signUpChannel"))}>
                  전화번호 변경
                </ContentButton>
              </div>
            </Content>

            <Content>
              <ContentTitle>생년월일</ContentTitle>
              <ContentInput>{userinfo.birth}</ContentInput>
            </Content>

            <Content>
              <ContentTitle>성별</ContentTitle>
              <div style={{ display: "flex", gap: "8px" }}>
                <ContentRadio active={userinfo.sex === "1" ? true : false}>
                  남성
                </ContentRadio>
                <ContentRadio active={userinfo.sex === "1" ? false : true}>
                  여성
                </ContentRadio>
              </div>
            </Content>
          </ContentBody>
          <ContentBody>
            <Content>
              <ContentTitle>신분증 정보</ContentTitle>
              <input
                type="file"
                id="fileData"
                accept="image/*"
                capture="camera"
                onChange={e => {
                  encodeFileToBase64(
                    e.target.files // img or canvas element
                  );
                }}
                hidden
              />
              {idCardState &&
                idCardState.data &&
                idCardState.data != null &&
                idCardState.data.value1 != "-1" &&
                idCardState.data.value1 != "undefined" && (
                  <img
                    id="preview"
                    // src={idCardData.file}
                    src={decodeURIComponent(idCardState.data.value1)}
                    style={{
                      width: "100%",
                      maxHeight: "400px",
                      borderRadius: "6px",
                    }}
                  />
                )}
              {idCardState &&
              idCardState.data &&
              idCardState.data != null &&
              idCardState.data.value2 != "0" ? (
                <div style={{ display: "flex", alignSelf: "flex-end" }}>
                  <LabelButton
                    htmlFor={checkVersion()}
                    severity="light"
                    small={true}
                    disable="on"
                    clickEvent={() => openIdCard()}>
                    신분증 재등록
                  </LabelButton>
                </div>
              ) : (
                <LabelButton
                  htmlFor={checkVersion()}
                  severity="light"
                  disable="on"
                  L_ICON={IC.etc.ICON_GRAY_PLUS}
                  clickEvent={() => openIdCard()}>
                  신분증 추가
                </LabelButton>
              )}
            </Content>
          </ContentBody>
          <ContentBody>
            {(getCookie("signUpChannel") === "000" ||
              getCookie("signUpChannel") === "500") && (
              <Content onClick={() => _O.OpenMenu("/membership/pwCng")}>
                <List
                  data={{
                    STATUS: "default",
                    CONTAINER_SHORT: true,
                    L_ICON: "",
                    TITLE: "비밀번호 변경",
                    R_ICON: ListIcon.RECEIPT.R_ICON.CHEVRON_DEFAULT,
                  }}
                />
              </Content>
            )}

            {getCookie("isAuthOk") == "9" && (
              <Content onClick={() => _O.OpenMenu("/membership/certification")}>
                <List
                  data={{
                    STATUS: "default",
                    CONTAINER_SHORT: true,
                    L_ICON: "",
                    TITLE: "본인인증",
                    R_ICON: ListIcon.RECEIPT.R_ICON.CHEVRON_DEFAULT,
                  }}
                />
              </Content>
            )}
          </ContentBody>
        </ContentsBody>
      </Container>
    </Fragment>
  );
};

const Container = styled.div`
  background: #fff;
  display: flex;
  flex-wrap: wrap;
`;

const ContentsBody = styled.div`
  width: 100vw;
  height: calc(100vh - 57px);
  overflow-y: auto;
  display: flex;
  flex-flow: column;
  gap: 8px;
  background-color: #fafafa;
  /* background-color: black; */
`;

const ContentBody = styled.div`
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  padding: 24px 20px;
  background-color: #fff;
`;

const Content = styled.div`
  width: 100%;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  padding: 0;
`;

const ContentTitle = styled.span`
  flex-grow: 1;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: left;
  color: #333;
`;

const ContentInput = styled.div`
  width: 100%;
  box-sizing: border-box;
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  border-radius: 6px;
  border: solid 1px #f0f0f0;
  background-color: #ededf0;
`;

const ContentButton = styled.button`
  width: 88px;
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex: none;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 0;
  border-radius: 6px;
  background-color: #48454d;
  color: #fff;
  font-size: 12px;
`;

const ContentRadio = styled.div`
  width: 80px;
  height: 40px;
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 0;
  opacity: 0.4;
  border-radius: 6px;
  background-color: ${props => (props.active ? "#48454d" : "#f7f7fa")};
  color: ${props => (props.active ? "#fff" : "#888")};
`;
